import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-brand-creamDark px-4 py-20" data-id="element-70">
      <div className="mx-auto max-w-2xl text-center" data-id="element-71">
        <div className="mb-6 inline-flex h-16 w-16 items-center justify-center rounded-full bg-white shadow-sm" data-id="element-72">
          <ShieldCheck className="h-8 w-8 text-brand-green" aria-hidden="true" data-id="element-73" />
        </div>
        <h2 className="mb-6 text-2xl font-black uppercase tracking-wide text-brand-text md:text-3xl" data-id="element-74">
          HOL DIR DEINE ZEIT ZURÜCK ODER WIR ERSTATTEN DEIN GELD
        </h2>
        <p className="mb-6 leading-relaxed text-brand-gray" data-id="element-75">
          7 Tage Garantie ohne Nachfragen. Wenn es nicht das ist, was du
          erwartet hast, erstatten wir dein Geld. Schreib uns eine E-Mail und
          fertig.
        </p>
        <a href="#" className="text-sm font-bold text-brand-text underline decoration-brand-terracotta underline-offset-4 transition-colors hover:text-brand-green focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-green" data-id="element-76">
          Vollständige Rückerstattungsrichtlinie
        </a>
      </div>
    </section>;
}